var getElementOuterWidth = function getElementOuterWidth(element) {
  var _window$getComputedSt = window.getComputedStyle(element),
      marginLeft = _window$getComputedSt.marginLeft,
      marginRight = _window$getComputedSt.marginRight;

  var elementMargins = parseFloat(marginLeft) + parseFloat(marginRight);
  return element.offsetWidth + elementMargins;
};

export default getElementOuterWidth;